import * as React from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import "./basicpopver.css"
//importing images 
import qrimage from "../Images/QRimage.png"
import applogo from "../Images/apple.png"
import googleplay from "../Images/googleplay.png"
import nepal from "../Images/nepalflag.png"
import america from "../Images/americaflag.png"
// importing icons from material ui
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import MoveToInboxOutlinedIcon from '@mui/icons-material/MoveToInboxOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';

function SaveMore(){
  return (
    <div className="saveMore">
        <div className='savemore--one'>
            <h3>Download the App</h3>
            <img className="qrimage" src={qrimage}alt='' />
            <div className='more--apps'>
              {/* Apple store */}
              <img src={applogo} alt="" />
              <div>
                <p>Download on the</p>
                <h3>App Store</h3>
              </div>
            </div>
        </div>
        <div className='savemore--two'>
            <label>Shopthrough our app to enjoy:</label>
            <ul>
              <li>Exclusive Vouchers</li>
              <li>Better deals</li>
              <li>Personalised recommendations</li>
              <li>Find out first</li>
            </ul>
            <div className='more--apps'>
              {/* Apple store */}
              <img src={googleplay} alt="" />
              <div>
                <p>Download on the</p>
                <h3>App Store</h3>
              </div>
            </div>
        </div>
    </div>
  )
}

function CustomerCare(){
  return (
    <div className='customer--care'>
      <div className='care'>
        <SupportAgentOutlinedIcon />
        <p>Help Center</p>
      </div>
      <div className='care'>
        <MoveToInboxOutlinedIcon />
        <p>Order</p>
      </div>
      <div className='care'>
        <LocalShippingOutlinedIcon />
        <p>Shipping & Delivery</p>
      </div>
      <div className='care'>
        <PaymentsOutlinedIcon />
        <p>Payment</p>
      </div>
      <div className='care'>
          <MonetizationOnOutlinedIcon />
          <p>Refund & Returns</p>
      </div>
    </div>
  )
}

function TrackMyOrder(){
  return (
    <div className="track--order">
      <h3>Track my order</h3>
      <label>Please confirm your email:</label>
      <input type="email" />
      <label>Your order number:</label>
      <div className='order--number'>
        <input type="text" placeholder="e.g.123456789" />
        <ArrowForwardIosOutlinedIcon className='arrow--rignt' />
      </div>
      <label>For any other inquiries, <span>Click here</span></label>
      

    </div>
  )
}

function Language(){
  return (
    <div className='language'>
      <div className='language-choose'>
          <img src={america} alt="" />
          <h3>English</h3>
      </div>
      <div className='language-choose'>
          <img src={nepal} alt="" />
          <h3>Nepali</h3>
      </div>
    </div>
  )
}

const Display =({title}) =>{
  if(title === "SAVE MORE ON APP"){
    return (
      <SaveMore />
    )
  }
  else if(title === "CUSTOMER CARE"){
    return (
      <CustomerCare />
    )
  }
  else if(title === "TRACK MY ORDER"){
    return (
      <TrackMyOrder />
    )
  }
  else if(title === "LANGUAGE"){
    return (
      <Language />
    )
  }
}


export default function BasicPopover(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div className='basicpopover'>
      <p className="popover-btn" aria-describedby={id} variant="contained" onClick={handleClick}>
        {props.title}
      </p>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Typography sx={{ p: 2 }}> 
            <Display title ={props.title} />
        </Typography>
      </Popover>
    </div>
  );
}
